import React, { createContext, useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

const initialState = {
  text: '',
  type: '',
  timeout: 0,
}

const AlertContext = createContext({
  ...initialState,
  setAlert: () => {},
  unsetAlert: () => {},
})

export function AlertProvider({ children, timeout }) {
  const [text, setText] = useState('')
  const [type, setType] = useState('')

  const setAlert = useCallback((_text, _type) => {
    setText(_text)
    setType(_type)
  }, [])

  const unsetAlert = useCallback(() => {
    setText('')
    setType('')
  }, [])

  const alertProviderValue = useMemo(
    () => ({ text, type, timeout, setAlert, unsetAlert }),
    [text, type, timeout, setAlert, unsetAlert],
  )

  return (
    <AlertContext.Provider value={alertProviderValue}>
      {children}
    </AlertContext.Provider>
  )
}

AlertProvider.propTypes = {
  children: PropTypes.node,
  timeout: PropTypes.number,
}
AlertProvider.defaultProps = {
  children: null,
  timeout: 5000,
}

export default AlertContext
